import { render } from "./CopyGroupProductsPage.vue?vue&type=template&id=372f6984"
import script from "./CopyGroupProductsPage.vue?vue&type=script&lang=js"
export * from "./CopyGroupProductsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__